import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from "react-router-dom";
import moment from "moment";
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from 'lodash';
import numeral from 'numeral';
import {isFloat} from 'validator';

// Components
import DateInput from "../../../components/common/date-input";
import Select from "../../../components/common/virtualized-select";
import SalesInvoiceLinesTable from "../../../components/common/SalesInvoiceLinesTable";
import SerieSelector from "../../../components/common/SerieSelector";

// Actions
import {createSalesInvoice, cleanSalesInvoices} from "../../../actions/sales-invoices";
import {getCustomers, cleanCustomers} from "../../../actions/customers";
import {getSalesOrders, cleanSalesOrders} from "../../../actions/sales-orders";
import {getProducts, getProduct, cleanProducts} from "../../../actions/products";
import {getSeries, cleanSeries} from "../../../actions/series";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class NewSalesInvoice extends Component {
    constructor(props) {
        super(props);
        let customer = -1,
            orders = [],
            margin = 0,
            lines = List([]),
            salesInvoiceSubtotal = numeral(0).format(),
            salesInvoiceVat = numeral(0).format(),
            salesInvoiceTotal = numeral(0).format()
        ;


        // New SalesInvoice from Customers
        if (this.props.location.state && this.props.location.state.customerId) {
            customer = this.props.location.state.customerId;
            if (customer !== -1) {
                this.props.getSalesOrders({
                    filters: {
                        customer: customer._id,
                        $or: [{
                            status: 'partial'
                        }, {
                            status: 'sent'
                        }]
                    },
                    projection: 'order_code',
                    deleteVirtuals: true
                });
            }
        }

        // New SalesInvoice from SalesOrder
        if (this.props.location.state && this.props.location.state.salesOrder) {
            customer = this.props.location.state.salesOrder.getIn(['customer', '_id']);
            orders = [{
                _id: this.props.location.state.salesOrder.get('_id'),
                order_code: this.props.location.state.salesOrder.get('order_code')
            }];
            margin = this.props.location.state.salesOrder.get('margin');
            lines = this.props.location.state.salesOrder.get('lines');
            salesInvoiceSubtotal = numeral(this.props.location.state.salesOrder.getIn(['statistics', 'subtotal'])).format();
            salesInvoiceVat = numeral(this.props.location.state.salesOrder.getIn(['statistics', 'vat'])).format();
            salesInvoiceTotal = numeral(this.props.location.state.salesOrder.getIn(['statistics', 'total'])).format();
            this.props.getSalesOrders({
                filters: {
                    customer,
                    $or: [{
                        status: 'partial'
                    }, {
                        status: 'sent'
                    }]
                },
                projection: 'order_code',
                deleteVirtuals: true
            });
        }

        this.state = {
            canSubmit: false,
            canNewLine: false,
            // series
            serieSelectedId: 'manual',
            serieSelectedValue: '',
            // object fields
            invoice_code: '',
            document_date: moment(),
            expiration_date: moment(),
            type: 'standard',
            customer,
            salesOrders: List([]),
            orders,
            comments: '',
            margin,
            lines,
            bank_info_name: '',
            bank_info_iban: '',
            bank_info_swift: '',
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            // lines
            product: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // Statistics
            salesInvoiceSubtotal,
            salesInvoiceVat,
            salesInvoiceTotal,
            // line edit index
            lineToEditIndex: -1
        };
    }
    componentDidMount() {
        this.props.getSeries({ document_type: 'sales_invoice' });
        this.props.getCustomers({
            filters: { status: 'active' },
            projection: 'customer_code basic_info.name',
            deleteVirtuals: true
        });
        this.props.getProducts({
            filters: { status: 'active' },
            projection: 'product_code name',
            deleteVirtuals: true
        });
    }
    componentDidUpdate(prevProps, prevState) {
        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let salesInvoiceSubtotal = 0, salesInvoiceVat = 0, salesInvoiceTotal = 0;

            this.state.lines.forEach(line => {
                const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

                salesInvoiceSubtotal = salesInvoiceSubtotal + calcLine.subtotal;
                salesInvoiceVat = salesInvoiceVat + calcLine.vatLine;
                salesInvoiceTotal = salesInvoiceTotal + calcLine.total;
            });

            this.setState({
                salesInvoiceSubtotal: numeral(salesInvoiceSubtotal).format(),
                salesInvoiceVat: numeral(salesInvoiceVat).format(),
                salesInvoiceTotal: numeral(salesInvoiceTotal).format()
            });
        }

        // Selected Serie
        if (this.props.series.size > 0 && this.props.series !== prevProps.series) {
            let serieSelectedId = 'manual', serieSelectedValue = '';

            this.props.series.forEach(serie => {
                if (serie.get('is_default')) {
                    serieSelectedId = serie.get('_id');
                    serieSelectedValue = serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                }
            });
            this.setState({ serieSelectedId, serieSelectedValue }, this.validateSalesInvoice)
        }

        // Handle salesOrders
        if (this.props.salesOrders !== prevProps.salesOrders && this.props.salesOrders instanceof List) {
            if (!(this.props.salesOrders.get(0) && this.props.salesOrders.get(0).get('lines'))) {
                this.setState({
                    salesOrders: this.props.salesOrders
                });
            }
            else {
                let lines = List([]);
                this.props.salesOrders.forEach(order => {
                    order.get('lines').forEach(line => {
                        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

                        line = line.set('sale_price', calcLine.salePrice);
                        line = line.set('total', calcLine.total);
                        lines = lines.push(line);
                    });
                });
                this.setState({
                    lines,
                    product: -1,
                    amount: 0,
                    price: 0,
                    discount: 0,
                    vat: 0,
                    total: 0
                }, this.validateIssue);
            }
        }

        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                if (products.size > 0) {
                    products = products.map(product => {
                        return product.set('select', `[${product.get('product_code')}] ${product.get('name')}`);
                    });
                }
                products = products.insert(0, Map({ _id: -1, select: 'Selecciona un producto' }));
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }
    }
    componentWillUnmount() {
        this.props.cleanSalesInvoices();
        this.props.cleanProducts();
        this.props.cleanSalesOrders();
        this.props.cleanCustomers();
        this.props.cleanSeries();
    }

    calculateLine = (amount, costPrice, margin, discount, vat) => {
        let salePrice, subtotalCost, discountLine, subtotal, vatLine, total;
        salePrice = _.round(_.round(costPrice, 5) / (1 - (_.round(margin, 2) / 100)), 2);
        subtotalCost = _.round(amount, 5) * salePrice;
        discountLine = subtotalCost * (_.round(discount, 2) / 100);
        subtotal = subtotalCost - discountLine;
        vatLine = subtotal * (_.round(vat, 2) / 100);
        total = _.round(subtotal + vatLine, 2);

        return {
            salePrice,
            subtotalCost,
            discountLine,
            subtotal,
            vatLine,
            total
        }
    };

    replaceLines = () => {
        const orderIds = this.state.orders.map(order => order._id);

        if (orderIds.length <= 0) {
            this.setState({
                lines: List([]),
                product: -1,
                amount: 0,
                price: 0,
                discount: 0,
                vat: 0,
                total: 0
            }, this.validateIssue);
        }
        else {
            this.props.getSalesOrders({
                filters: {
                    _id: { $in: orderIds }
                },
                projection: 'lines',
                populateRefs: true,
                calculateStatistics: 'issues',
                deleteVirtuals: true
            });
        }
    };
    getLineToEdit = index => {
        const line = this.state.lines.get(index);
        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

        window.scrollTo(0, 0);

        this.props.getProduct(line.getIn(['product', '_id']), {
            projection: '_id',
            populateRefs: true
        });

        this.setState({
            product: line.getIn(['product', '_id']),
            selectedCostPrice: -1,
            commentsLine: line.get('comments'),
            amount: line.get('amount'),
            cost_price: line.get('cost_price'),
            sale_price: calcLine.salePrice,
            discount: line.get('discount'),
            vat: line.get('vat'),
            newLinePvp: _.round(calcLine.subtotalCost, 2),
            newLineDiscount: _.round(calcLine.discountLine, 2),
            newLineVat: _.round(calcLine.vatLine, 2),
            total: calcLine.total,
            lineToEditIndex: index
        }, this.validateLine);
    };
    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        });
    };
    onChangeSerieSelected = (serieSelectedId, serieSelectedValue) => {
        this.setState({
            serieSelectedId,
            serieSelectedValue,
            invoice_code: ''
        }, this.validateSalesInvoice);
    };
    validateLine = () => {
        if (this.state.amount !== 0) {
            this.setState({ canNewLine: true }, this.validateSalesInvoice);
        } else {
            this.setState({ canNewLine: false }, this.validateSalesInvoice);
        }
    };
    validateSalesInvoice = () => {
        if (
            (this.state.serieSelectedId !== 'manual' || this.state.invoice_code !== '') &&
            this.state.document_date.isValid() &&
            this.state.expiration_date.isValid() &&
            this.state.type !== '' &&
            this.state.customer !== -1 &&
            this.state.margin !== '' &&
            this.state.bank_info_name !== ''
        ) {
            this.setState({ canSubmit: true });
        } else {
            this.setState({ canSubmit: false });
        }
    };
    handleCreateClick = () => {
        let lines = new List([]);

        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .delete('sale_price')
                .delete('total')
            );
        });

        this.props.createSalesInvoice({
            serieSelectedId: this.state.serieSelectedId,
            invoice_code: this.state.invoice_code,
            document_date: this.state.document_date,
            expiration_date: this.state.expiration_date,
            type: this.state.type,
            customer: this.state.customer,
            orders: this.state.orders.map(order => order._id),
            comments: this.state.comments,
            margin: this.state.margin,
            lines,
            bank_info: {
                name: this.state.bank_info_name,
                iban: this.state.bank_info_iban,
                swift: this.state.bank_info_swift
            }
        }, {
            projection: 'invoice_code document_date expiration_date customer statistics.subtotal statistics.vat statistics.total status',
            populateRefs: [{
                field: 'customer',
                projection: 'basic_info.name'
            }],
            calculateStatistics: 'sales-invoices',
            deleteVirtuals: true
        });
        this.props.history.push('/ventas/facturas');
    };

    render() {
        // SalesInvoiceTypes
        const salesInvoiceTypes = List([
            Map({
                type: 'standard',
                label: 'Estándar'
            }), Map({
                type: 'proforma',
                label: 'Proforma'
            }), Map({
                type: 'corrected',
                label: 'Correctiva'
            })
        ]);

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/ventas/facturas">Facturas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Nueva Factura</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button
                                className="btn btn-cancel"
                                onClick={ () => this.props.history.push('/ventas/facturas') }
                            >Cancelar
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={ this.handleCreateClick }
                                disabled={!this.state.canSubmit}
                            >Crear
                            </button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Código de factura de ventas *</label>
                                                <div className="row">
                                                    <div className="col" style={{ paddingRight: 0 }} >
                                                        { this.state.serieSelectedId === 'manual'
                                                            ? <input
                                                                className="form-control"
                                                                type="text"
                                                                value={this.state.invoice_code}
                                                                onChange={ (event) => {
                                                                    this.setState({
                                                                        invoice_code: event.target.value
                                                                    }, this.validateSalesInvoice);
                                                                }}
                                                            />
                                                            : <input
                                                                className="form-control"
                                                                type="text"
                                                                value={ this.state.serieSelectedValue }
                                                                disabled={true}
                                                            />
                                                        }
                                                    </div>
                                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                                        { this.props.series.size > 0
                                                            ? <SerieSelector
                                                                series={this.props.series}
                                                                serieSelectedId={this.state.serieSelectedId}
                                                                onChangeSerieSelected={this.onChangeSerieSelected}
                                                            />
                                                            : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha factura *</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            document_date: selectedDate
                                                        }, this.validateSalesInvoice);
                                                    }}
                                                    value={this.state.document_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha vencimiento *</label>
                                                <DateInput
                                                    onChange={(selectedDate) => {
                                                        this.setState({
                                                            expiration_date: selectedDate
                                                        }, this.validateSalesInvoice);
                                                    }}
                                                    value={this.state.expiration_date}
                                                    inputWrapperStyle={{height: 40}}
                                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                                    iconStyle={{top: 9, right: 12}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Tipo de factura *</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={salesInvoiceTypes.toJS()}
                                                    value={this.state.type}
                                                    labelKey="label"
                                                    valueKey="type"
                                                    matchProp="label"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    onChange={(salesInvoiceType) => {
                                                        if (salesInvoiceType && salesInvoiceType.type !== this.state.type) {
                                                            this.setState({
                                                                type: salesInvoiceType.type
                                                            }, this.validateSalesInvoice);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <label>Cliente *</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.props.customers.toJS()}
                                                value={this.state.customer}
                                                labelKey="select"
                                                valueKey="_id"
                                                matchProp="select"
                                                multi={false}
                                                searchable={true}
                                                clearable={false}
                                                onChange={(customer) => {
                                                    if (customer && customer._id !== this.state.customer) {
                                                        if (customer._id !== -1) {
                                                            this.props.getSalesOrders({
                                                                filters: {
                                                                    customer: customer._id,
                                                                    status: 'sent'
                                                                },
                                                                projection: 'order_code',
                                                                deleteVirtuals: true
                                                            });
                                                        }
                                                        this.setState({
                                                            customer: customer._id,
                                                            orders: []
                                                        }, this.validateSalesInvoice);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }}>
                                        <div className="col-6">
                                            <label>Pedidos de venta relacionados</label>
                                            <Select
                                                className="virtualized-select"
                                                options={this.state.salesOrders.toJS()}
                                                value={this.state.orders}
                                                labelKey="order_code"
                                                valueKey="_id"
                                                matchProp="order_code"
                                                multi={true}
                                                placeholder={this.state.customer === -1 ? "Selecciona un cliente" : "Selecciona un pedido de venta"}
                                                disabled={this.state.customer === -1}
                                                searchable={true}
                                                clearable={false}
                                                removeSelected={false}
                                                closeOnSelect={false}
                                                onChange={(selectedValues) => this.setState({ orders: selectedValues }, this.validateSalesInvoice)}
                                            />
                                        </div>
                                        <div className="col-6" style={{ paddingTop: 25 }}>
                                            <button
                                                type="button"
                                                className="btn btn-custom"
                                                onClick={ this.replaceLines }
                                            >
                                                Actualizar lineas de factura
                                            </button>
                                            <Icon
                                                icon="info-sign"
                                                style={{ margin: '-7px 10px', color: '#000' }}
                                                title="Reemplaza las lineas actuales por las lineas de los pedidos seleccionados"
                                            />
                                        </div>
                                    </div>
                                    <div className="row" style={{ paddingBottom: 16 }} >
                                        <div className="col-9">
                                            <label>Comentarios</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.comments}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        comments: event.target.value
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <label>Margen (%) *</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.margin}
                                                onChange={ (event) => {
                                                    let margin = event.target.value;
                                                    let lines = List([]);
                                                    let calcLine = {};

                                                    if (margin === '') margin = '0';
                                                    if (margin >= 100) margin = '99';
                                                    if (isFloat(margin)) {
                                                        // actual lines
                                                        this.state.lines.forEach(line => {
                                                            calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), margin, line.get('discount'), line.get('vat'));
                                                            lines = lines.push(Map({
                                                                _id: line.get('_id'),
                                                                product: line.get('product'),
                                                                comments: line.get('comments'),
                                                                amount: line.get('amount'),
                                                                cost_price: line.get('cost_price'),
                                                                sale_price: calcLine.salePrice,
                                                                discount: line.get('discount'),
                                                                vat: line.get('vat'),
                                                                total: calcLine.total
                                                            }));
                                                        });
                                                        // new line
                                                        calcLine = this.calculateLine(this.state.amount, this.state.cost_price, margin, this.state.discount, this.state.vat);
                                                        this.setState({
                                                            margin: _.round(margin, 2),
                                                            sale_price: calcLine.salePrice,
                                                            newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                            newLineDiscount: _.round(calcLine.discountLine, 2),
                                                            newLineVat: _.round(calcLine.vatLine, 2),
                                                            total: calcLine.total,
                                                            lines
                                                        }, this.validateSalesInvoice);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <h4>Lineas de factura { this.state.lineToEditIndex !== -1 ? <span style={{
                                        paddingLeft: '50px',
                                        color: '#1AB394',
                                        fontStyle: 'italic',
                                        fontWeight: 'bold'
                                    }}>- Modo edición de línea -</span> : '' }</h4>
                                    <div style={{
                                        transition: 'all 0.4s',
                                        margin: '0 -10px',
                                        padding: '10px 10px 0',
                                        ...this.state.lineToEditIndex !== -1 ? { boxShadow: '0 0 10px 1px #1AB394' } : {}
                                    }}>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col-3">
                                                <label>Producto *</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.state.products.toJS()}
                                                    value={this.state.product}
                                                    labelKey="select"
                                                    valueKey="_id"
                                                    matchProp="select"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    onChange={(product) => {
                                                        if (product && product._id !== this.state.product) {
                                                            if (product._id !== -1) {
                                                                this.props.getProduct(product._id, {
                                                                    projection: '_id',
                                                                    populateRefs: true
                                                                });
                                                            }
                                                            this.setState({
                                                                product: product._id,
                                                                selectedCostPrice: -1,
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-3">
                                                <label>Últimos costes del producto</label>
                                                <Select
                                                    className="virtualized-select"
                                                    options={this.state.costPrices.toJS()}
                                                    value={this.state.selectedCostPrice}
                                                    labelKey="price"
                                                    valueKey="_id"
                                                    matchProp="price"
                                                    multi={false}
                                                    searchable={true}
                                                    clearable={false}
                                                    disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                                    onChange={(selectedCostPrice) => {
                                                        if (selectedCostPrice) {
                                                            if (selectedCostPrice._id !== -1) {
                                                                let cost_price = selectedCostPrice.price;
                                                                let calcLine = {};

                                                                if (cost_price === '') cost_price = '0';
                                                                if (isFloat(cost_price.toString())) {
                                                                    calcLine = this.calculateLine(this.state.amount, cost_price, this.state.margin, this.state.discount, this.state.vat);
                                                                    this.setState({
                                                                        selectedCostPrice: selectedCostPrice._id,
                                                                        cost_price,
                                                                        sale_price: calcLine.salePrice,
                                                                        newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                                        newLineDiscount: _.round(calcLine.discountLine, 2),
                                                                        newLineVat: _.round(calcLine.vatLine, 2),
                                                                        total: calcLine.total
                                                                    }, this.validateLine);
                                                                }
                                                            }
                                                            else {
                                                                this.setState({ selectedCostPrice: selectedCostPrice._id });
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <label>Comentarios</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.commentsLine}
                                                    onChange={ (event) => {
                                                        this.setState({
                                                            commentsLine: event.target.value
                                                        });
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingBottom: 16 }} >
                                            <div className="col">
                                                <label>Cantidad *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.amount}
                                                    onChange={ (event) => {
                                                        let amount = event.target.value;
                                                        let calcLine = {};

                                                        if (amount === '') amount = '0';
                                                        if (isFloat(amount)) {
                                                            calcLine = this.calculateLine(amount, this.state.cost_price, this.state.margin, this.state.discount, this.state.vat);
                                                            this.setState({
                                                                amount,
                                                                sale_price: calcLine.salePrice,
                                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                                total: calcLine.total
                                                            }, this.validateLine);
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Precio coste ud *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.cost_price}
                                                    onChange={ (event) => {
                                                        let cost_price = event.target.value;
                                                        let calcLine = {};

                                                        if (cost_price === '') cost_price = '0';
                                                        if (isFloat(cost_price)) {
                                                            calcLine = this.calculateLine(this.state.amount, cost_price, this.state.margin, this.state.discount, this.state.vat);
                                                            this.setState({
                                                                cost_price,
                                                                sale_price: calcLine.salePrice,
                                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                                total: calcLine.total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>PVP ud</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.sale_price}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Descuento (%)</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.discount}
                                                    onChange={ (event) => {
                                                        let discount = event.target.value;
                                                        let calcLine = {};

                                                        if (discount === '') discount = '0';
                                                        if (isFloat(discount)) {
                                                            calcLine = this.calculateLine(this.state.amount, this.state.cost_price, this.state.margin, discount, this.state.vat);
                                                            this.setState({
                                                                discount,
                                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                                total: calcLine.total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>IVA (%) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.vat}
                                                    onChange={ (event) => {
                                                        let vat = event.target.value;
                                                        let calcLine = {};

                                                        if (vat === '') vat = '0';
                                                        if (isFloat(vat)) {
                                                            calcLine = this.calculateLine(this.state.amount, this.state.cost_price, this.state.margin, this.state.discount, vat);
                                                            this.setState({
                                                                vat,
                                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                                total: calcLine.total
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.product === -1}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>PVP (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLinePvp}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Descuento (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLineDiscount}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>IVA (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.newLineVat}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>Total (€) *</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={this.state.total}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col-auto" style={{ paddingTop: 23 }} >
                                                { this.state.lineToEditIndex !== -1
                                                    ? <button
                                                        className="btn btn-primary"
                                                        disabled={!this.state.canNewLine}
                                                        onClick={() => {
                                                            let lines = new List(this.state.lines);
                                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                                            const product = this.state.products.get(index);

                                                            lines = lines.set(this.state.lineToEditIndex, Map({
                                                                product,
                                                                comments: this.state.commentsLine,
                                                                amount: _.round(this.state.amount, 5),
                                                                cost_price: _.round(this.state.cost_price, 5),
                                                                sale_price: this.state.sale_price,
                                                                discount: _.round(this.state.discount, 2),
                                                                vat: _.round(this.state.vat, 5),
                                                                total: _.round(this.state.total, 2)
                                                            }));

                                                            this.setState({
                                                                lines,
                                                                product: -1,
                                                                selectedCostPrice: -1,
                                                                commentsLine: '',
                                                                amount: 0,
                                                                cost_price: 0,
                                                                sale_price: 0,
                                                                vat: 0,
                                                                newLinePvp: 0,
                                                                newLineDiscount: 0,
                                                                newLineVat: 0,
                                                                discount: 0,
                                                                total: 0,
                                                                canNewLine: false,
                                                                lineToEditIndex: -1
                                                            }, this.validateSalesInvoice);
                                                        }}
                                                    >
                                                        <Icon
                                                            style={{ margin: '2px 0px' }}
                                                            icon="tick" title="Guardar"
                                                        />
                                                    </button>
                                                    : <button
                                                        className="btn btn-custom"
                                                        disabled={!this.state.canNewLine}
                                                        onClick={() => {
                                                            let lines = new List(this.state.lines);
                                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                                            const product = this.state.products.get(index);

                                                            lines = lines.insert(lines.size, Map({
                                                                _id: lines.size,
                                                                product,
                                                                comments: this.state.commentsLine,
                                                                amount: _.round(this.state.amount, 5),
                                                                cost_price: _.round(this.state.cost_price, 5),
                                                                sale_price: this.state.sale_price,
                                                                discount: _.round(this.state.discount, 2),
                                                                vat: _.round(this.state.vat, 5),
                                                                total: _.round(this.state.total, 2)
                                                            }));

                                                            this.setState({
                                                                lines,
                                                                product: -1,
                                                                selectedCostPrice: -1,
                                                                commentsLine: '',
                                                                amount: 0,
                                                                cost_price: 0,
                                                                sale_price: 0,
                                                                vat: 0,
                                                                newLinePvp: 0,
                                                                newLineDiscount: 0,
                                                                newLineVat: 0,
                                                                discount: 0,
                                                                total: 0,
                                                                canNewLine: false
                                                            }, this.validateSalesInvoice);
                                                        }}
                                                    >
                                                        <Icon
                                                            style={{ margin: '2px 0px' }}
                                                            icon="plus" title="Añadir"
                                                        />
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <SalesInvoiceLinesTable
                                        editMode={true}
                                        salesInvoiceLines={this.state.lines}
                                        deleteLine={this.deleteLine}
                                        getLineToEdit={this.getLineToEdit}
                                        editLineIndex={this.state.lineToEditIndex}
                                    />
                                    <div className="row stats-zone d-flex justify-content-end">
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.salesInvoiceSubtotal }</span>
                                            <span>Subtotal</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.salesInvoiceVat }</span>
                                            <span>IVA</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label ">{ this.state.salesInvoiceTotal }</span>
                                            <span>Total</span>
                                        </div>
                                    </div>
                                    <h4>Datos bancarios</h4>
                                    <div className="row">
                                        <div className="col-6">
                                            <label>Banco *</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.bank_info_name}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        bank_info_name: event.target.value
                                                    }, this.validateSalesInvoice);
                                                }}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <label>IBAN</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.bank_info_iban}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        bank_info_iban: event.target.value
                                                    });
                                                }}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <label>Switft</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={this.state.bank_info_swift}
                                                onChange={ (event) => {
                                                    this.setState({
                                                        bank_info_swift: event.target.value
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const customersReducer = state.customers;
    const salesOrdersReducer = state.salesOrders;
    const productsReducer = state.products;
    const seriesReducer = state.series;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);
    if (customers.size > 0) {
        customers = customers.map(customer => {
            return customer.set('select', `[${customer.get('customer_code')}] ${customer.getIn(['basic_info', 'name'])}`);
        });
    }
    customers = customers.insert(0, Map({ _id: -1, select: 'Selecciona un cliente' }));

    // SalesOrders
    let salesOrders = salesOrdersReducer.get('payload') || List([]);

    // Products
    const products = productsReducer.get('payload') || List([]);

    // Series
    let series = seriesReducer.get('payload') || List([]);

    return {
        customers,
        salesOrders,
        products,
        series
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        getSalesOrders: (query) => dispatch(getSalesOrders(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        getSeries: (query) => dispatch(getSeries(query)),
        createSalesInvoice: (salesInvoice, options) => dispatch(createSalesInvoice(salesInvoice, options)),
        cleanSalesInvoices: () => dispatch(cleanSalesInvoices()),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanSalesOrders: () => dispatch(cleanSalesOrders()),
        cleanProducts: () => dispatch(cleanProducts()),
        cleanSeries: () => dispatch(cleanSeries())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewSalesInvoice);



// WEBPACK FOOTER //
// ./src/containers/sales/invoices/NewSalesInvoices.js